export class AuthUserInfo {
  constructor(
    public token?: string,
    public refresh_token?: string,
    public token_type?: string,
    public userName?: string,
    public fullName?: string,
    public role?: any,
    public menuItems?: any[],
    public expires_at?: number,
    public useSSO?: boolean,
    public alreadyLoggedIn?: boolean,
    public activities?: any[]
  ) {}
}
export class AccountModel {
  constructor(
    public userName?: string,
    public password?: string,
    public captcha?: any
  ) {}
}

export class SiteUserModel {
  constructor(
    public activities?: any[],
    public currentSessionID?: string,
    public email?: string,
    public emailRecipientClass?: string,
    public firstName?: string,
    public lastLoginTime?: string,
    public lastName?: string,
    public locked?: boolean,
    public menues?: any[],
    public middleName?: string,
    public notSiteSpecific?: string,
    public ntID?: string,
    public password?: string,
    public rId?: string,
    public refNo?: string,
    public role?: string,
    public roleRefNo?: string,
    public site?: string,
    public siteId?: string,
    public username?: string
  ) {}
}
export class FeatureModel {
  constructor(
    public activityRId?: string,
    public activityId?: string,
    public modificationType?: string,
    public modificationTypeString?: string,
    public name?: string,
    public selected?: boolean
  ) {}
}
